import { useTranslation } from 'react-i18next';
import { ReactComponent as InfoIcon } from '../../assets/alertSign.svg';
import styles from './DeepFakeModal.module.scss';

export const DeepFakeModal = ({ isOpen, onClose, imageUrl, selectedOption, probability }) => {
  const { t } = useTranslation();

  // Define the result states: 0 = authentic, 1 = suspicious
  const resultStates = {
    0: {
      title: t('Suspicious'),
      text: t('This media has been identified as synthetically generated or manipulated with high confidence.'),
      color: '#dc3545', // red
      isAuthentic: false
    },
    1: {
      title: t('Authentic'),
      text: t('This media has been identified as genuine with high confidence.'),
      color: '#28a745', // green
      isAuthentic: true
    }
  };

  if (!isOpen) return null;

  const currentState = resultStates[selectedOption];

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>{t('Report Status')}</h2>
          <button className={styles.closeButton} onClick={onClose}>
            &times;
          </button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.imageSection}>
            <img src={imageUrl} alt={t('Analyzed content')} />
          </div>

          <div className={styles.detailsSection}>
            <div className={styles.alertBox} style={{ backgroundColor: `${currentState.color}15`, borderColor: currentState.color }}>
              <div className={styles.alertHeader}>
                <InfoIcon className={styles.alertIcon} style={{ fill: currentState.color }} />
                <h3 style={{ color: currentState.color }}>{currentState.title}</h3>
              </div>
              <p className={styles.alertText}>{currentState.text}</p>
            </div>

            <div className={styles.probabilitySection}>
              <div className={styles.probabilityHeader}>
                <span style={{ color: currentState.color }} className={styles.probabilityLabel}>{t('Manipulation Probability')}</span>
                <span style={{ color: currentState.color }} className={styles.probabilityValue}>{probability}%</span>
              </div>
              <div className={styles.progressBarContainer}>
                <div className={styles.progressBar}>
                  <div
                    className={styles.progressFill}
                    style={{ width: `${probability}%` }}
                  ></div>
                </div>
              </div>
            </div>

            {!currentState.isAuthentic && (
              <div className={styles.manipulationIndicator}>
                <span className={styles.indicatorLabel}>{t('Manipulation Indicator')}:</span>
                <span className={styles.indicatorValue}>{t('AI-generated content')}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};